export default "__VITE_ASSET__BeAexxWv__"